import UniversalNotificationsStore from './UniversalNotificationsStore'

export default UniversalNotificationsStore
